module.exports = __webpack_public_path__ + "static/media/sales-order-slide-3.9b296ec6.jpg";